var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgManualMeasure = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 250,
    viewBox: "0 0 200 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 29,
    y: 175.44,
    width: 142,
    height: 32.56,
    rx: 2,
    stroke: "#424243",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 184C35 184.552 35.4477 185 36 185C36.5523 185 37 184.552 37 184H35ZM35 176V184H37V176H35Z",
    fill: "#424243"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35 184C35 184.552 35.4477 185 36 185C36.5523 185 37 184.552 37 184H35ZM35 176V184H37V176H35Z",
    fill: "#424243"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M43 180C43 180.552 43.4477 181 44 181C44.5523 181 45 180.552 45 180H43ZM43 176V180H45V176H43Z",
    fill: "#424243"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43 180C43 180.552 43.4477 181 44 181C44.5523 181 45 180.552 45 180H43ZM43 176V180H45V176H43Z",
    fill: "#424243"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M51 184C51 184.552 51.4477 185 52 185C52.5523 185 53 184.552 53 184H51ZM51 176V184H53V176H51Z",
    fill: "#424243"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M51 184C51 184.552 51.4477 185 52 185C52.5523 185 53 184.552 53 184H51ZM51 176V184H53V176H51Z",
    fill: "#424243"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M59 180C59 180.552 59.4477 181 60 181C60.5523 181 61 180.552 61 180H59ZM59 176V180H61V176H59Z",
    fill: "#424243"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M59 180C59 180.552 59.4477 181 60 181C60.5523 181 61 180.552 61 180H59ZM59 176V180H61V176H59Z",
    fill: "#424243"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M67 184C67 184.552 67.4477 185 68 185C68.5523 185 69 184.552 69 184H67ZM67 176V184H69V176H67Z",
    fill: "#424243"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M67 184C67 184.552 67.4477 185 68 185C68.5523 185 69 184.552 69 184H67ZM67 176V184H69V176H67Z",
    fill: "#424243"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M75 180C75 180.552 75.4477 181 76 181C76.5523 181 77 180.552 77 180H75ZM75 176V180H77V176H75Z",
    fill: "#424243"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M75 180C75 180.552 75.4477 181 76 181C76.5523 181 77 180.552 77 180H75ZM75 176V180H77V176H75Z",
    fill: "#424243"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M83 184C83 184.552 83.4477 185 84 185C84.5523 185 85 184.552 85 184H83ZM83 176V184H85V176H83Z",
    fill: "#424243"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M83 184C83 184.552 83.4477 185 84 185C84.5523 185 85 184.552 85 184H83ZM83 176V184H85V176H83Z",
    fill: "#424243"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M91 180C91 180.552 91.4477 181 92 181C92.5523 181 93 180.552 93 180H91ZM91 176V180H93V176H91Z",
    fill: "#424243"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M91 180C91 180.552 91.4477 181 92 181C92.5523 181 93 180.552 93 180H91ZM91 176V180H93V176H91Z",
    fill: "#424243"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M99 184C99 184.552 99.4477 185 100 185C100.552 185 101 184.552 101 184H99ZM99 176V184H101V176H99Z",
    fill: "#424243"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M99 184C99 184.552 99.4477 185 100 185C100.552 185 101 184.552 101 184H99ZM99 176V184H101V176H99Z",
    fill: "#424243"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M107 180C107 180.552 107.448 181 108 181C108.552 181 109 180.552 109 180H107ZM107 176V180H109V176H107Z",
    fill: "#424243"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M107 180C107 180.552 107.448 181 108 181C108.552 181 109 180.552 109 180H107ZM107 176V180H109V176H107Z",
    fill: "#424243"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M115 184C115 184.552 115.448 185 116 185C116.552 185 117 184.552 117 184H115ZM115 176V184H117V176H115Z",
    fill: "#424243"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M115 184C115 184.552 115.448 185 116 185C116.552 185 117 184.552 117 184H115ZM115 176V184H117V176H115Z",
    fill: "#424243"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M123 180C123 180.552 123.448 181 124 181C124.552 181 125 180.552 125 180H123ZM123 176V180H125V176H123Z",
    fill: "#424243"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M123 180C123 180.552 123.448 181 124 181C124.552 181 125 180.552 125 180H123ZM123 176V180H125V176H123Z",
    fill: "#424243"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M131 184C131 184.552 131.448 185 132 185C132.552 185 133 184.552 133 184H131ZM131 176V184H133V176H131Z",
    fill: "#424243"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M131 184C131 184.552 131.448 185 132 185C132.552 185 133 184.552 133 184H131ZM131 176V184H133V176H131Z",
    fill: "#424243"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M139 180C139 180.552 139.448 181 140 181C140.552 181 141 180.552 141 180H139ZM139 176V180H141V176H139Z",
    fill: "#424243"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M139 180C139 180.552 139.448 181 140 181C140.552 181 141 180.552 141 180H139ZM139 176V180H141V176H139Z",
    fill: "#424243"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M147 184C147 184.552 147.448 185 148 185C148.552 185 149 184.552 149 184H147ZM147 176V184H149V176H147Z",
    fill: "#424243"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M147 184C147 184.552 147.448 185 148 185C148.552 185 149 184.552 149 184H147ZM147 176V184H149V176H147Z",
    fill: "#424243"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M155 180C155 180.552 155.448 181 156 181C156.552 181 157 180.552 157 180H155ZM155 176V180H157V176H155Z",
    fill: "#424243"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M155 180C155 180.552 155.448 181 156 181C156.552 181 157 180.552 157 180H155ZM155 176V180H157V176H155Z",
    fill: "#424243"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M163 184C163 184.552 163.448 185 164 185C164.552 185 165 184.552 165 184H163ZM163 176V184H165V176H163Z",
    fill: "#424243"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M163 184C163 184.552 163.448 185 164 185C164.552 185 165 184.552 165 184H163ZM163 176V184H165V176H163Z",
    fill: "#424243"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M84.0459 41.48C81.4434 58.28 72.6654 76.7258 64.9615 94.76C53.0213 122.711 36.0413 142.384 54.1182 155.72C61.9256 161.48 68.8654 158.12 71.9015 155.72",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M117.442 41C120.045 57.8 128.823 76.2459 136.527 94.28C148.467 122.231 165.447 141.904 147.37 155.24C139.562 161 132.623 157.64 129.587 155.24",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M71.4692 141.8C76.7138 142.598 84.2694 143.875 86.0175 155.366C88.2028 169.73 112.24 169.16 115.276 157.64C117.492 149.234 123.186 143.795 128.722 141.8",
    stroke: "#424243",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgManualMeasure);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/manual_measure.e7f3a87659c2609477cdae0d53b6c1bb.svg";